// -------------Placeholder for input---------------------------
function placeholderInput() {
    $(".input__input")
    .on("focus", function(){
        $(this).next('.input__placeholder').css({"top":"-8px"});
        $(this).addClass('active_input');
    })
    .on("blur", function(){
        if ($(this).val() == "") {
            $(this).next('.input__placeholder').css({"top":"11px"});
            $(this).removeClass('active_input');
        }
    });
}

// --------------Placeholder for input-------------------------------
$(document).ready(function(){
    placeholderInput();
// --------------Маска на телефон--------------------------------
    Inputmask({
       mask: "+38 (999) 999-99-99",
       clearMaskOnLostFocus: true,
       clearIncomplete: true,
       showMaskOnHover: false,
   }).mask('.phone');
// --------------Маска на телефон--------------------------------
// ---------- Форма на странице Контакты feedback---------------------
    $("#checkbox_feedback").change(function() {
       if(this.checked){
           $("#do_feedback").removeClass('js_disabled');
           $('.js_feedback_label').removeClass('js_red');
       } else {
           $("#do_feedback").addClass('js_disabled');
           $('.js_feedback_label').addClass('js_red');
       }
   });

   $("#do_feedback").click(function (e) {
        if(!$(this).hasClass('js_disabled')) {
            $("#feedback").submit();
            $('.js_feedback_label').removeClass('js_red');
        } else {
            $('.js_feedback_label').addClass('js_red');
        }
	});

    $("#feedback").validate({
        errorElement: 'span',
        errorClass: 'input__error',
        ignoreTitle: true,
      errorPlacement: function(error, element) {
          error.appendTo($(element).parents('.js_input_block'));
      },
      highlight: function(element) {
          $(element).parents('.js_input_wrapper').addClass("forms__error");
      },
      unhighlight: function(element) {
          $(element).parents('.js_input_wrapper').removeClass("forms__error");
      },
        submitHandler: function(form) {
            var csrf_token = $('meta[name="csrf-token"]').attr('content');
            var formdata = $("#feedback").serialize();
            $("#feedback")[0].reset();
            $.ajax({
                url: routes.postSend,
                type: 'POST',
                data: {
                    "_token" : csrf_token,
                     "data": formdata,
                     "subj": "feedback",
                },
                success: function(data) {
                    $('#success_feedback').removeClass('js_hide');
                    $(".input__input").next('.input__placeholder').css({"top":"11px"});
                    $(".input__input").removeClass('active_input');
                  setTimeout(function() {
                     $('#success_feedback').addClass('js_hide');
                 }, 4000)
                }
            })
        }
    });
// ---------- Форма на странице Контакты feedback---------------------
// -------------Test drive and Offer form-------------------------------
    $(".js_checkbox_privacy").change(function() {
        var checkbox_name = $(this).attr('data-name');
       if(this.checked){
           $(".js_form_button[data-name="+checkbox_name+"]").removeClass('js_disabled');
           $(this).next('.js_label_privacy').removeClass('js_red');
       } else {
           $(".js_form_button[data-name="+checkbox_name+"]").addClass('js_disabled');
       }
    });

    $(".js_form_button").click(function (e) {
        var form_name = $(this).attr('data-name');
        var form = $('.js_form[id='+form_name+']');
         if(!$(this).hasClass('js_disabled')) {
             $('.js_label_privacy').removeClass('js_red');
             if(form.find(".js_checkbox_contact:checked").length == 0) {
                 form.find(".js_checkbox_contact").addClass('js_red');
             } else {
                 if(form_name == "test_drive") {
                     $("#test_drive").submit();
                 } else if (form_name == "offer_form") {
                     $("#offer_form").submit();
                 }
             }
         } else {
             $('.js_label_privacy').addClass('js_red');
         }
  });

  $(".js_checkbox_contact").change(function() {
       if(this.checked){
           $(".js_checkbox_contact").removeClass('js_red');
       }
   });

   $("#test_drive").validate({
       errorElement: 'span',
       errorClass: 'input__error',
       ignoreTitle: true,
     errorPlacement: function(error, element) {
         error.appendTo($(element).parents('.js_input_block'));
     },
     highlight: function(element) {
         $(element).parents('.js_input_wrapper').addClass("forms__error");
     },
     unhighlight: function(element) {
         $(element).parents('.js_input_wrapper').removeClass("forms__error");
     },
       submitHandler: function(form) {
           var csrf_token = $('meta[name="csrf-token"]').attr('content');
           var formdata = $("#test_drive").serialize();
           $("#test_drive")[0].reset();
           $.ajax({
               url: routes.postSend,
               type: 'POST',
               data: {
                   "_token" : csrf_token,
                    "data": formdata,
                    "subj": "test_drive",
               },
               success: function(data) {
                   $('#success_test_drive').removeClass('js_hide');
                   $(".input__input").next('.input__placeholder').css({"top":"11px"});
                   $(".input__input").removeClass('active_input');
                   $('.js_select').selectric({
                       disableOnMobile: false,
                       nativeOnMobile: false
                   });
                 setTimeout(function() {
                    $('#success_test_drive').addClass('js_hide');
                }, 4000)
               }
           })
       }
   });

   $("#offer_form").validate({
       errorElement: 'span',
       errorClass: 'input__error',
       ignoreTitle: true,
     errorPlacement: function(error, element) {
         error.appendTo($(element).parents('.js_input_block'));
     },
     highlight: function(element) {
         $(element).parents('.js_input_wrapper').addClass("forms__error");
     },
     unhighlight: function(element) {
         $(element).parents('.js_input_wrapper').removeClass("forms__error");
     },
       submitHandler: function(form) {
           var csrf_token = $('meta[name="csrf-token"]').attr('content');
           var formdata = $("#offer_form").serialize();
           $("#offer_form")[0].reset();
           $.ajax({
               url: routes.postSend,
               type: 'POST',
               data: {
                   "_token" : csrf_token,
                    "data": formdata,
                    "subj": "get_offetr",
               },
               success: function(data) {
                   $('#success_offer_form').removeClass('js_hide');
                   $(".input__input").next('.input__placeholder').css({"top":"11px"});
                   $(".input__input").removeClass('active_input');
                   $('.js_select').selectric({
                       disableOnMobile: false,
                       nativeOnMobile: false
                   });
                 setTimeout(function() {
                    $('#success_offer_form').addClass('js_hide');
                }, 4000)
               }
           })
       }
   });


// -------------Test drive and Offer form-------------------------------
});
